import React from 'react'
import "../assets/css/loading.css"

function Loading() {
  return (
    <div className="loader">
      <div className="box1"></div>
      <div className="box2"></div>
      <div className="box3"></div>
    </div>
  );
}

export default Loading